import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-financeiro-modal-deletar',
  templateUrl: './financeiro-modal-deletar.component.html',
  styleUrls: ['./financeiro-modal-deletar.component.css'],
  standalone: false
})
export class FinanceiroModalDeletarComponent {
  @Input() contaParaDeletar: any;
  @Output() fechar = new EventEmitter<void>();
  @Output() confirmar = new EventEmitter<void>();

  fecharModal() {
    this.fechar.emit();
  }

  confirmarDelecao() {
    this.confirmar.emit();
  }
}
